import { render } from "./CreateGroupsModal.vue?vue&type=template&id=7722471f&scoped=true"
import script from "./CreateGroupsModal.vue?vue&type=script&lang=js"
export * from "./CreateGroupsModal.vue?vue&type=script&lang=js"

import "./CreateGroupsModal.vue?vue&type=style&index=0&id=7722471f&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7722471f"]])

export default __exports__